import { RoleGroup } from '@community_dev/types/lib/api/v1/Roles'
import { Col, Row, Switch } from 'antd'
import type { JSX } from 'react'
import { useTheme } from 'styled-components'

import { Client, Role } from 'api/clients'
import { SeatRoles } from 'constants/roles'
import { getRoleLabel, isRoleDisabled, isRoleInRoles, toggleRole } from 'utils/roles'

export type AdditionalRoleTogglesProps = {
  /** The full list of roles available on the account. */
  allRoles: Role[]
  selectedRoles: Role[]
  isDownloadEnabled: boolean
  client: Client
  onChange(nextRoles: Role[]): void
}

export function AdditionalRoleToggles({
  allRoles,
  selectedRoles,
  isDownloadEnabled,
  client,
  onChange,
}: AdditionalRoleTogglesProps): JSX.Element {
  const { COLORS } = useTheme() || {}
  const dataDownloaderRole = allRoles.find((role) => role.name === SeatRoles.DATA_DOWNLOADER)
  return (
    <>
      <label htmlFor="canExport">Data Export</label>
      {isDownloadEnabled && dataDownloaderRole ? (
        <Row gutter={16}>
          <Col data-testid={`toggle-${SeatRoles.DATA_DOWNLOADER}`} span={3}>
            <Switch
              checked={isRoleInRoles(dataDownloaderRole, selectedRoles)}
              id="canExport"
              // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
              name="Export Settings"
              onChange={() => onChange(toggleRole(dataDownloaderRole, selectedRoles))}
              style={{ margin: '10px 0 0 5px' }}
            />
          </Col>
          <Col span={20} style={{ color: COLORS?.SUBTEXT }}>
            This Team Member {isRoleInRoles(dataDownloaderRole, selectedRoles) ? 'can' : 'can’t'} download data from the{' '}
            <a href="https://data-export.community.com" rel="noopener noreferrer" target="_blank">
              Data Exporter Tool
            </a>
            .
          </Col>
        </Row>
      ) : (
        <Row style={{ color: COLORS?.SUBTEXT }}>
          Data Exports are disabled for ”{client.firstName} {client.lastName}”
        </Row>
      )}
      <label>Integrations</label>
      {allRoles
        .filter((role) => role.group !== RoleGroup.PRIMARY && role.name !== SeatRoles.DATA_DOWNLOADER)
        .map((role) => {
          return (
            <Row gutter={16} key={role.id}>
              <Col data-testid={`toggle-integration-${role.name}`} span={3}>
                <Switch
                  checked={isRoleInRoles(role, selectedRoles)}
                  disabled={isRoleDisabled(role)}
                  onChange={() => onChange(toggleRole(role, selectedRoles))}
                  style={{ margin: '10px 0 0 5px' }}
                />
              </Col>
              <Col span={20} style={{ color: COLORS?.SUBTEXT, marginTop: '12px' }}>
                {getRoleLabel(role)}
              </Col>
            </Row>
          )
        })}
    </>
  )
}
